import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "progress-container"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "personalDetails" };
const _hoisted_4 = {
    key: 0,
    class: "well"
};
const _hoisted_5 = { class: "anchor-bottom submitControls" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useInvestments, pendingInvestmentRevalidate } from '@/composables/useInvestments';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddInvestmentPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getInvestmentProviders, getInvestmentTypes, getInvestmentAccount, addInvestment: apiAddInvestment, updateInvestment: apiUpdateInvestment } = useInvestments();
        const { getAiopSection } = useContent();
        const validationText = ref(null);
        const sectionNo = ref(0);
        const currentPageNumber = ref(0);
        const sections = ref([]);
        const breadCrumb = ref([]);
        const inputSections = ref(null);
        const investmentHeader = computed(() => {
            const verb = route.params.id ? 'Edit' : 'Add';
            if (!sections.value || !sections.value[0] || !sections.value[0].fields || !sections.value[0].fields[0] || !sections.value[0].fields[0].value) {
                return verb + " investment details";
            }
            return verb + " " + sections.value[0].fields[0].value + " Investment details";
        });
        const progressValue = computed(() => {
            if (totalPages.value === 0)
                return 0;
            return ((currentPageNumber.value + 1) / totalPages.value) * 100;
        });
        const totalPages = computed(() => {
            return sectionsAvailableCount(findFieldValue('Type'));
        });
        const isCurrentSectionValid = computed(() => {
            if (!sections.value || !sections.value[sectionNo.value] || !sections.value[sectionNo.value].fields) {
                return false;
            }
            for (const field of sections.value[sectionNo.value].fields) {
                if (field.required && (!field.value || field.value === "")) {
                    return false;
                }
            }
            return true;
        });
        // --- Helpers (inlined from Helpers mixin) ---
        function findFieldValue(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function findField(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName) {
                        return field;
                    }
                }
            }
            return null;
        }
        function loadFieldsFromObject(fieldMappings) {
            Object.keys(fieldMappings).forEach(fieldName => {
                sections.value.forEach((section) => {
                    section.fields.forEach((field) => {
                        if (field.label === fieldName) {
                            field.value = fieldMappings[fieldName];
                        }
                    });
                });
            });
        }
        function removeNullProperties(obj) {
            Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
            return obj;
        }
        function sectionAllowed(section) {
            if (!section.rule)
                return true;
            const [ruleKey, ruleValue] = section.rule.split(':').map((s) => s.trim());
            const ruleValues = ruleValue.split(',').map((s) => s.trim());
            for (let i = 0; i < sectionNo.value; i++) {
                const sec = sections.value[i];
                for (const field of sec.fields) {
                    if (field.id === ruleKey && ruleValues.includes(field.value)) {
                        return true;
                    }
                }
            }
            return false;
        }
        function inputControlGoNext(onFinished = null, before = null) {
            validationText.value = '';
            let allOK = true;
            if (before) {
                if (!before())
                    return;
            }
            for (const field of sections.value[sectionNo.value].fields) {
                if (field.required && (!field.value || field.value === "")) {
                    validationText.value = field.validationText;
                    allOK = false;
                    break;
                }
                if (field.type === 'datetext' && field.value.length < 10) {
                    validationText.value = "Please enter date in the format dd/mm/yyyy";
                    allOK = false;
                    break;
                }
                if (field.strongPass != undefined && field.strongPass == false) {
                    validationText.value = "Your password is not strong enough";
                    allOK = false;
                    break;
                }
            }
            if (allOK) {
                let allowed = false;
                breadCrumb.value.push({ sectionNo: sectionNo.value });
                while (!allowed) {
                    validationText.value = null;
                    sectionNo.value++;
                    if (!sections.value[sectionNo.value]) {
                        if (onFinished) {
                            onFinished();
                            return;
                        }
                    }
                    else {
                        allowed = sectionAllowed(sections.value[sectionNo.value]);
                    }
                }
                currentPageNumber.value++;
                inputSections.value.next(sectionNo.value);
            }
            setTimeout(() => { validationText.value = null; }, 4000);
        }
        function inputControlGoBack() {
            const crumb = breadCrumb.value.pop();
            sectionNo.value = crumb.sectionNo;
            validationText.value = null;
            currentPageNumber.value--;
            inputSections.value.back(sectionNo.value);
        }
        function preValidate() {
            validationText.value = null;
            const now = new Date();
            sections.value[sectionNo.value].fields.forEach((field) => {
                if (field.type === 'datetext' && field.value) {
                    const [day, month, year] = field.value.split('/');
                    const date = new Date(year, month - 1, day);
                    if (field.future && date < now) {
                        validationText.value = `${field.label} must be in the future`;
                        return false;
                    }
                    if (field.past && date > now) {
                        validationText.value = `${field.label} must be in the past`;
                        return false;
                    }
                }
            });
            return !validationText.value;
        }
        // --- Page methods ---
        function populateFields(policy) {
            const fieldMappings = {
                'Type': policy.accountType.subType,
                'Provider': policy.provider ? policy.provider.name : null,
                'Account number': policy.accountNumber,
                'Allowance used this year': policy.taxYearAllowanceUsed,
                'Estimated Value': policy.balance,
                'Ownership': policy.jointStatus === 2 ? 'Joint' : 'Sole',
            };
            loadFieldsFromObject(fieldMappings);
        }
        function addInvestment() {
            const accountType = {
                name: "Investment",
                subType: findFieldValue('Type') || null,
            };
            const providerName = findFieldValue('Provider') || null;
            const provider = providerName ? { name: providerName } : null;
            const investment = {
                accountType: accountType,
                accountNumber: findFieldValue('Account number') || null,
                taxYearAllowanceUsed: findFieldValue('Allowance used this year') || 0,
                balance: findFieldValue('Estimated Value') || null,
                provider: provider,
                jointStatus: findFieldValue('Ownership') === 'Joint' ? 2 : findFieldValue('Ownership') === 'Sole' ? 1 : null,
            };
            removeNullProperties(investment);
            if (route.params.id) {
                investment.id = route.params.id;
            }
            const handleResponse = (res) => {
                if (res) {
                    if (route.params.id) {
                        getInvestmentAccount(route.params.id, null, true);
                    }
                    // Flag the investment list for SWR+poll on the next read (MoneyPage):
                    // the /InvestmentHubAccounts cache lags the write, so let it
                    // reconcile in the background rather than refetching stale data now.
                    pendingInvestmentRevalidate.value = true;
                    router.push({ path: '/assetsuccess', query: { type: 'investment', id: res.id } });
                }
            };
            if (!route.params.id) {
                apiAddInvestment(investment, handleResponse);
            }
            else {
                apiUpdateInvestment(investment, handleResponse);
            }
        }
        function sectionsAvailableCount(insuranceType) {
            const sectionsNoRule = sections.value.filter((section) => !section.rule);
            const sectionsMatchingRule = sections.value.filter((section) => section.rule && section.rule.includes(insuranceType));
            return sectionsNoRule.length + sectionsMatchingRule.length;
        }
        function onLoad() {
            console.log('onLoad');
            getAiopSection('AddInvestmentPageSections.json', () => {
                sections.value = state.sectionJson;
                if (route.params.id) {
                    getInvestmentAccount(route.params.id, (policy) => {
                        populateFields(policy);
                    });
                }
                getCustomer();
                getInvestmentProviders((res) => {
                    res = res.filter((item) => item.cashISA === true || item.other === true || item.investmentISA === true || item.trading === true)
                        .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name));
                    const providerField = findField('Provider');
                    if (providerField) {
                        providerField.showAvatars = true;
                        providerField.items = res.map((provider) => {
                            return provider.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            });
                        });
                    }
                });
                getInvestmentTypes((res) => {
                    res = res.filter((item) => item.name === "Investment");
                    const typeField = findField('Type');
                    if (typeField) {
                        typeField.items = res.map((investmentType) => {
                            return investmentType.subType.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            });
                        });
                    }
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: investmentHeader.value,
                    bgcolor: "white",
                    border: "0"
                }, null, 8, ["title"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer && _unref(state).policyTypes && _unref(state).investmentProviders
                }, null, 8, ["customer"]),
                (totalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_progress_linear, {
                            "model-value": progressValue.value,
                            rounded: ""
                        }, null, 8, ["model-value"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).policyTypes && _unref(state).investmentProviders && (_unref(state).investmentAccount || !_unref(route).params.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "centered small" }, "Don't forget you can whatsapp us your documents and we will add you investments for you!", -1)),
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(InputSections, {
                                        ref_key: "inputSections",
                                        ref: inputSections,
                                        sections: sections.value,
                                        theme: "light"
                                    }, null, 8, ["sections"]),
                                    (validationText.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createElementVNode("p", null, _toDisplayString(validationText.value), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(MGButton, {
                                            alt: false,
                                            text: "Next",
                                            arrow: true,
                                            fullWidth: true,
                                            disabled: !isCurrentSectionValid.value,
                                            onClick: _cache[0] || (_cache[0] = ($event) => (inputControlGoNext(addInvestment, preValidate)))
                                        }, null, 8, ["disabled"]),
                                        (currentPageNumber.value > 0)
                                            ? (_openBlock(), _createBlock(MGButton, {
                                                key: 0,
                                                stacked: true,
                                                outline: true,
                                                fullWidth: true,
                                                text: "Back",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (inputControlGoBack()))
                                            }))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
